import AuthService from '../services/auth.service';

const user = JSON.parse(sessionStorage.getItem('user'));
//const payment = JSON.parse(localStorage.getItem('payment'));
const initialState = user
  ? { status: { loggedIn: true }, user , ApplicantID : 0 ,Menuhide:false , payment : [] , renderReview : 1 }
  : { status: { loggedIn: false }, user: null , ApplicantID:0 , Menuhide:true , payment : [] ,renderReview : 1};

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, user) {
      return AuthService.login(user).then(
        user => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    ExternalLogin({ commit }, user) {
      return AuthService.Externallogin(user).then(
        user => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
      
    },
    register({ commit }, user) {
      return AuthService.register(user).then(
        response => {
          commit('registerSuccess');
          return Promise.resolve(response.data);
        },
        error => {
          commit('registerFailure');
          return Promise.reject(error);
        }
      );
    },
    payment({ commit }, payment){
      commit('updatePayment',payment);
    },
    Review({ commit }, renderReview){
      commit('ReviewUpdate',renderReview);
    }
  },
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
      state.Menuhide = false
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
      state.Menuhide = true
      
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
      state.Menuhide = true
     
    },
    registerSuccess(state,ApplicantID) {
      state.status.loggedIn = false;
      state.ApplicantID = ApplicantID
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    },
    updatePayment(state,payment){
      state.paymentList = payment ;
    },
    ReviewUpdate(state,renderReview){
      state.renderReview = renderReview ;
    }
  }
};
